/* eslint-disable max-len */
import { useContext, useEffect, useMemo, useState } from "react";
import { Row, useScreenClass } from "react-grid-system";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { Col } from "../../components/StyledGridSystem";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import { useLocation } from "react-router-dom";
import { SemesterContext } from "../../context/SemesterContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { StyledAddButton } from "../RoadMap/RoadMap";
import Icon from "../../components/Icon";
import SelectStudentModal from "../../components/SelectStudentModal";
import { LocationInterface } from "../../components/UtilsComponents";
import StudentHistoryModel from "../../components/StudentHistoryModel";
import SnackBar from "../../components/SnackBar";
import CompetencyDetailModal from "../../components/CompetencyDetailModal";
import TableComponent, {
  StyledTableCell,
  StyledTableRow,
} from "../../components/Table";
import { Menu, MenuItem, TableBody, TableHead, TableRow } from "@mui/material";
import CreditsDropdown from "../../components/CreditsDropdown";
import moment from "moment";
import ConfirmModal from "../../components/ConfirmModal";
import ViewDetailModal from "./ViewDetailModal";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import { StyleElements } from "../RoadMap/StudentTimelines";
import MinimalSelect from "../../components/MinimalSelect";
import { UniversityContext } from "../../context/UniversityContext";

const CustomFlex = styled(FlexBox) <{ $sidebarOpen: boolean }>`
  left: ${({ $sidebarOpen }) => ($sidebarOpen ? "455px" : "275px")};
  z-index: 1000;
  position: fixed;
  top: 0px;
  height: 74px;
}
`;
const CustomRow = styled(Row)`
  margin-bottom: 0px;
  height: calc(100vh - 84px);
  height: -moz-calc(100vh - 84px);
  height: -o-calc(100vh - 84px);
  height: -webkit-calc(100vh - 84px);
`;
type Card = {
  assessed_skills: number;
  competency_code: string;
  credits: number;
  id: string;
  mastery_level: number;
  mastery_level_title: string;
  required: boolean;
  status: string;
  title: string;
  total_skills: number;
  transferred: boolean;
  action: any;
  provides_credit: boolean;
  // is_cross_version: boolean;
  detail: any;
};
interface Column {
  id:
  | "competency_code"
  | "title"
  | "credits"
  | "status"
  | "total_skills"
  | "assessed_skills"
  | "mastery_level_title"
  | "action"
  // | "is_cross_version"
  | "provides_credit"
  | "detail";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}
const columns: readonly Column[] = [
  { id: "competency_code", label: "Competency Code", minWidth: 100 },
  { id: "title", label: "Competency Title", minWidth: 200 },
  {
    id: "credits",
    label: "Credits",
    minWidth: 80,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "status",
    label: "Status",
    minWidth: 80,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "total_skills",
    label: "Number of Skills",
    minWidth: 100,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "assessed_skills",
    label: "Number Assessed",
    minWidth: 100,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "provides_credit",
    label: "Provides Credit",
    minWidth: 10,
  },
  {
    id: "mastery_level_title",
    label: "Mastery Level",
    minWidth: 100,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "detail",
    label: "",
    minWidth: 10,
    format: (value: number) => value.toLocaleString("en-US"),
  },
  {
    id: "action",
    label: "",
    minWidth: 10,
    format: (value: number) => value.toLocaleString("en-US"),
  },
];

type Student = {
  advisor: string;
  cmkl_id: string;
  current_status: any;
  curriculum_version: number;
  display_version: string;
  email: string;
  expect_last_term: string;
  first_name: string;
  first_term: string;
  id: string;
  last_name: string;
  last_term: string;
  nickname: string;
  program: string;
  program_id: string;
  study_year: string;
  university_code: string;
  programs: Array<any>;
};

function InstructorStudentCreditsPage() {
  const screenClass = useScreenClass();
  let location = useLocation() as LocationInterface;
  const stateData = location.state;
  const [loading, setLoading] = useState<boolean>(false);
  // const [selectedStudent, setSelectedStudent] = useState<any>();
  const currentUser = useContext(UserContext).user;
  const userContext = useContext(UserContext);
  const semesterContext = useContext(SemesterContext);
  const universityContext = useContext(UniversityContext);

  const isMobile = useMemo(
    () => ["xs", "sm", "md"].includes(screenClass),
    [screenClass]
  );
  const [credits, setCredits] = useState<Array<Card>>([]);
  const [confirm, setConfirm] = useState<boolean>(false);
  const [confirmExtend, setConfirmExtend] = useState<boolean>(false);
  const [confirmDelete, setConfirmDelete] = useState<boolean>(false);
  // const [confirmArchive, setConfirmArchive] = useState<boolean>(false);
  const [isMessageOpen, setIsMessageOpen] = useState<boolean>(false);
  const [messageType, setMessageType] =
    useState<"error" | "success" | "warning" | "info">("error");
  const [message, setMessage] = useState<string>("");
  const [messageHeader, setMessageHeader] = useState<string>("");
  const [selectedCard, setSelectedCard] = useState<Card>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [totalCredits, setTotalCredits] = useState(0);
  const [totalRecordedCredits, setRecordedCredits] = useState(0);
  const [isDetailOpen, setIsDetailOpen] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [status, setStatus] = useState<string | number>("N/A");
  const [statusTypes, setStatusTypes] = useState<Array<any>>([]);

  // const selectedStudent: any = JSON.parse(
  //   localStorage.getItem("selectedStudent") as string
  // );

  const [selectedStudent, setSelectedStudent] = useState<Student>({
    advisor: "",
    cmkl_id: "",
    current_status: "",
    curriculum_version: 0,
    display_version: "",
    email: "",
    expect_last_term: "",
    first_name: "",
    first_term: "",
    id: "",
    last_name: "",
    last_term: "",
    nickname: "",
    program: "",
    programs: [],
    program_id: "",
    study_year: "",
    university_code: "",
  });

  const CreditStyle = styled("div")`
    padding: 10px 5px;
    display: flex;
    justify-content: start;
    align-items: center;
    color: #2fff00;
  `;
  useEffect(() => {
    const stored = localStorage.getItem("selectedStudent");
    if (stored) {
      try {
        setSelectedStudent(JSON.parse(stored));
      } catch (e) {
        console.error("Failed to parse student", e);
      }
    }
    statusTypes.length === 0 && fetchStatusTypes();

    if (selectedStudent && selectedStudent?.id) {
      fetchCredits(selectedStudent?.id);
    }
  }, [
    semesterContext,
    stateData,
    statusTypes,
    universityContext.selectedProgram,
    localStorage.getItem("selectedStudent")
  ]);

  const fetchStatusTypes = () => {
    axios
      .get("/student/status/type")
      .then((res) => {
        setStatusTypes(res.data?.student_status_type);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const fetchCredits = (id: string) => {
    setLoading(true);
    console.log('university context selected program', universityContext.selectedProgram, JSON.parse(localStorage.getItem("selectedStudent") || "{}")
      ?.programs?.[0]?.program_name);
    axios
      .get(
        `/student/cards/semester?student_id=${id}&semester_name=${semesterContext.selectedSemester?.label
        }&program_name=${JSON.parse(localStorage.getItem("selectedStudent") || "{}")
          ?.programs?.[0]?.program_name
        }`
      )
      .then((res) => {
        if (res.data.card_info.cards) {
          setCredits(res.data.card_info.cards);
          const total = res.data.card_info.cards.reduce(
            (sum: number, competency: any) =>
              competency.competency_code.includes("SOF")
                ? sum
                : sum + competency.credits,
            0
          );
          const totalRecordedCredits = res.data.card_info.cards.reduce(
            (sum: number, competency: any) => {
              if (
                competency.status === "Recorded" &&
                !competency.competency_code.includes("SOF")
              ) {
                return sum + competency.credits;
              }
              return sum;
            },
            0
          );
          setTotalCredits(total);
          setRecordedCredits(totalRecordedCredits);
        } else {
          setCredits([]);
          setTotalCredits(0);
          setRecordedCredits(0);
        }
        setLoading(false);
      })
      .catch(() => {
        setCredits([]);
        setTotalCredits(0);
        setRecordedCredits(0);
        setLoading(false);
      })
      .finally(() => {
        selectedStudent?.id && semesterContext.selectedSemester?.label &&
          axios
            .get(
              `/student/semester/status?student_id=${selectedStudent?.id}&program_id=${selectedStudent?.programs?.[0]?.id}&semester_name=${semesterContext.selectedSemester?.label}`
            )
            .then((res) => {
              setStatus(
                res.data?.data?.[0]?.student_term_ordinal === 0
                  ? res.data?.data?.[0]?.comment
                  : res.data?.data?.[0]?.new_status || "N/A"
              );
            })
            .catch((err) => {
              console.log(err);
            });
      });
  };
  const recordCredits = () => {
    setLoading(true);
    axios
      .get(
        `/student/credit/record?student_id=${selectedStudent?.id}&competency_card_id=${selectedCard?.id}`
      )
      .then((res) => {
        setLoading(false);
        setConfirm(false);
        setMessage(res.data.status.message);
        if (res.data.status.success === true) {
          setMessageType("success");
          setMessageHeader("Success!");
          fetchCredits(selectedStudent.id);
        } else {
          setMessageType("error");
          setMessageHeader("Error!");
        }
        setIsMessageOpen(true);
        setConfirm(false);
      })
      .catch(function (error) {
        if (error.response) {
          setLoading(false);
          setMessage(error.response.data.error || "Something went wrong!");
          setMessageType("error");
          setMessageHeader("Error!");
          setIsMessageOpen(true);
        }
      });
  };
  // const archiveCredits = () => {
  //   setLoading(true);
  //   axios
  //     .post("/card/archive", {
  //       student_id: selectedStudent.id,
  //       card_id: selectedCard?.id,
  //       semester_name: semesterContext.selectedSemester?.label,
  //     })
  //     .then((res) => {
  //       setLoading(false);
  //       setConfirmArchive(false);
  //       setMessage("Card archived successfully");
  //       if (res.data.card) {
  //         setMessageType("success");
  //         setMessageHeader("Success!");
  //         fetchCredits(selectedStudent.id);
  //       } else {
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //       }
  //       setIsMessageOpen(true);
  //       setConfirmDelete(false);
  //     })
  //     .catch(function (error) {
  //       if (error.response) {
  //         setLoading(false);
  //         setMessage(error.response.data.error || "Something went wrong!");
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //         setIsMessageOpen(true);
  //       }
  //     });
  // };
  const deleteCredits = () => {
    setLoading(true);
    axios
      .delete(
        `/card/delete?student_id=${selectedStudent?.id}&card_id=${selectedCard?.id}`
      )
      .then((res) => {
        setLoading(false);
        setConfirmDelete(false);
        setMessage(res.data.success);
        if (res.data.success) {
          setMessageType("success");
          setMessageHeader("Success!");
          fetchCredits(selectedStudent?.id);
        } else {
          setMessageType("error");
          setMessageHeader("Error!");
        }
        setIsMessageOpen(true);
        setConfirmDelete(false);
      })
      .catch(function (error) {
        if (error.response) {
          setLoading(false);
          setMessage(error.response.data.error || "Something went wrong!");
          setMessageType("error");
          setMessageHeader("Error!");
          setIsMessageOpen(true);
        }
      });
  };
  const getSemester = (index: number) => {
    if (index + 1 > semesterContext.semesters.length) {
      return semesterContext.selectedSemester;
    }
    return semesterContext.semesters[index];
  };
  // const extendCredits = () => {
  //   setLoading(true);
  //   const semesterIndex = semesterContext.semesters.findIndex((el) => {
  //     return el.label === semesterContext.selectedSemester?.label;
  //   });
  //   axios
  //     .post("/card/extend", {
  //       student_id: selectedStudent?.id,
  //       card_id: selectedCard?.id,
  //       semester_name: getSemester(semesterIndex + 1).label,
  //     })
  //     .then((res) => {
  //       setLoading(false);
  //       setConfirmExtend(false);
  //       setMessage("Extended card successfully");
  //       if (res.data.card) {
  //         setMessageType("success");
  //         setMessageHeader("Success!");
  //         fetchCredits(selectedStudent?.id);
  //       } else {
  //         setMessage("Error on Extending card");
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //       }
  //       setIsMessageOpen(true);
  //       setConfirmDelete(false);
  //     })
  //     .catch(function (error) {
  //       if (error.response) {
  //         setLoading(false);
  //         setMessage(error.response.data.error || "Something went wrong!");
  //         setMessageType("error");
  //         setMessageHeader("Error!");
  //         setIsMessageOpen(true);
  //       }
  //     });
  // };
  const openRecordModal = (data: any) => {
    if (data) {
      setSelectedCard(data);
      setConfirm(true);
    }
  };
  const openDeleteModal = (data: any) => {
    if (data) {
      setSelectedCard(data);
      setConfirmDelete(true);
    }
  };
  // const openArchiveModal = (data: any) => {
  //   if (data) {
  //     setSelectedCard(data);
  //     setConfirmArchive(true);
  //   }
  // };

  // Drop Course Modal
  const openExtendModal = (course: any) => {
    setSelectedCard(course);
    setConfirmExtend(true);
  };
  function compareTwoDates(first: Date, second: Date) {
    return moment(first).isAfter(second);
  }

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRemoveStudent = () => {
    console.log('removed')
    localStorage.removeItem("selectedStudent");

    window.dispatchEvent(new Event("selected-student-changed"));

    setSelectedStudent({
      advisor: "",
      cmkl_id: "",
      current_status: "",
      curriculum_version: 0,
      display_version: "",
      email: "",
      expect_last_term: "",
      first_name: "",
      first_term: "",
      id: "",
      last_name: "",
      last_term: "",
      nickname: "",
      program: "",
      program_id: "",
      study_year: "",
      university_code: "",
      programs: [],
    });
    localStorage.removeItem("selectedStudent");
    setCredits([]);
    setTotalCredits(0);
    setRecordedCredits(0);
    setSelectedRow({});
    setSelectedCard(undefined);
    handleMenuClose();
  };

  const handleSelectStudent = () => {
    setIsModalOpen(true);
    handleMenuClose();
  };

  return (
    <>
      {isModalOpen && (
        <SelectStudentModal
          isOpen={isModalOpen}
          setOpen={setIsModalOpen}
          setStudent={(stu) => {
            setSelectedStudent(stu);
            localStorage.setItem("selectedStudent", JSON.stringify(stu));
            // semesterContext.setSemester(
            //   // semesterContext?.semesters?.[
            //   //   semesterContext?.semesters?.length - 1
            //   // ]
            //   semesterContext?.semesters?.find(
            //     (sem) =>
            //       sem.label ===
            //       stu?.programs?.[0]?.current_status?.semester_name
            //   ) ||
            //   semesterContext?.semesters?.[
            //     semesterContext?.semesters?.length - 1
            //   ]
            // );
            semesterContext.setStudent(stu);
            fetchCredits(stu.id);
            // window.location.reload();
          }}
        />
      )}
      <ViewDetailModal
        credits={credits}
        title="Skills"
        isOpen={isDetailOpen}
        setOpen={setIsDetailOpen}
        selectedRow={selectedRow}
      />
      <ConfirmModal
        title="Record Competency"
        description={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon
              fixedWidth={false}
              style={{ width: "24px", height: "24px" }}
              size={3}
              mr={1}
              name="warning"
            />
            Are you sure you want to record this competency?
          </div>
        }
        setOpen={setConfirm}
        isOpen={confirm}
        confirmFunction={() => {
          recordCredits();
        }}
      />
      {/* <ConfirmModal
        title="Extend Competency"
        description="Are you sure you want to extend this competency?"
        setOpen={setConfirmExtend}
        isOpen={confirmExtend}
        confirmFunction={() => {
          extendCredits();
        }}
      /> */}
      <ConfirmModal
        title="Delete Competency"
        description="Are you sure you want to delete this competency?"
        setOpen={setConfirmDelete}
        isOpen={confirmDelete}
        confirmFunction={() => {
          deleteCredits();
        }}
      />
      {/* <ConfirmModal
        title="Archive Competency"
        description="Are you sure you want to archive this competency?"
        setOpen={setConfirmArchive}
        isOpen={confirmArchive}
        confirmFunction={() => {
          archiveCredits();
        }}
      /> */}
      <SnackBar
        isOpen={isMessageOpen}
        setOpen={setIsMessageOpen}
        header={messageHeader}
        message={message}
        type={messageType}
      />
      <CreditStyle>
        Student Credits{" "}
        <div
          style={{
            border: "1px solid #86868636",
            marginLeft: 10,
            color: "white",
            padding: "5px 10px",
            borderRadius: 5,
          }}
        >
          Total : {totalCredits}, Recorded : {totalRecordedCredits}{" "}
        </div>
        {selectedStudent.id && (
          <div
            style={{
              color: "white",
              display: "flex",
              alignItems: "center",
              marginLeft: 20,
            }}
          >
            Status in {semesterContext.selectedSemester?.label} :
            <div
              style={{
                width: 10,
                height: 10,
                margin: 4,
                borderRadius: "50%",
                background:
                  status === 1
                    ? "#75fb4e"
                    : status === 2
                      ? "#03a9f4"
                      : status === 3
                        ? "orange"
                        : "yellow",
              }}
            />
            <span
              style={{
                color:
                  status === 1
                    ? "#75fb4e"
                    : status === 2
                      ? "#03a9f4"
                      : status === 3
                        ? "orange"
                        : "yellow",
              }}
            >
              {(statusTypes.length > 0 &&
                statusTypes?.find((type) => type.id === status)?.title) ||
                status}
            </span>
          </div>
        )}
      </CreditStyle>

      <CustomFlex $sidebarOpen={userContext.roadmapView.sidebar}>
        <FlexGrow style={{ flexGrow: 0 }}>
          {selectedStudent.id ? (
            <>
              <StyledAddButton
                style={{ margin: 0, whiteSpace: "nowrap", fontWeight: "600" }}
                onClick={handleMenuClick}
              >
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  mr={1}
                  name="user"
                />
                {selectedStudent?.nickname}
              </StyledAddButton>
              <Menu
                id="student-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "student-button",
                }}
              >
                <MenuItem
                  onClick={handleRemoveStudent}
                  style={{ color: "#ff1100" }}
                >
                  <Icon name="user-minus" mr={1} />
                  Remove Current Student
                </MenuItem>
                <MenuItem
                  onClick={handleSelectStudent}
                  style={{ color: "#305ed7" }}
                >
                  <Icon name="exchange" mr={1} />
                  Change Student
                </MenuItem>
              </Menu>
            </>
          ) : (
            <StyledAddButton
              style={{ margin: 0, whiteSpace: "nowrap", fontWeight: "600" }}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <Icon
                fixedWidth={false}
                style={{ width: "24px", height: "24px" }}
                size={3}
                mr={1}
                name="user"
              />
              Select Student
            </StyledAddButton>
          )}
        </FlexGrow>
        {/* hide until Christine fixes the api */}
        {/* <FlexGrow style={{ flexGrow: 0 }}>
          <StyleElements>
            <MinimalSelect
              setClass={"custom-container"}
              required
              placeholder="Program"
              options={universityContext.programs}
              value={universityContext.programs?.find(
                (v: any) =>
                  v.program_abbrev ===
                  universityContext.selectedProgram?.program_abbrev
              )}
              onChange={(newValue: any) => {
                universityContext.setProgram(newValue);
              }}
            />
          </StyleElements>
        </FlexGrow> */}
      </CustomFlex>
      <CustomRow
        wrap="nowrap"
        style={{ marginLeft: "-12px", marginRight: "-10px", maxHeight: "80vh" }}
      >
        <Col style={{ padding: 0 }}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <TableComponent height="85vh" aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{
                        minWidth: column.minWidth,
                        fontWeight: "bold",
                        borderBottom: "1px solid #3C406C",
                      }}
                    >
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {credits.length === 0 ? (
                  <>
                    {!selectedStudent ? (
                      <StyledTableRow role="checkbox" tabIndex={-1} key={0}>
                        <StyledTableCell colSpan={6} key={1} align="center">
                          Select a student to see competencies
                        </StyledTableCell>
                      </StyledTableRow>
                    ) : (
                      <StyledTableRow role="checkbox" tabIndex={-1} key={0}>
                        <StyledTableCell colSpan={6} key={1} align="center">
                          No competencies found for the selected semester
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </>
                ) : (
                  <>
                    {credits.map((row, index) => {
                      if (!row.competency_code.includes("SOF"))
                        return (
                          <StyledTableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                          >
                            {columns.map((column: Column) => {
                              const value = row[column.id];
                              // if (column.id === "action") {
                              //   if (
                              //     semesterContext.selectedSemester
                              //       .final_assess_date !== "" &&
                              //     compareTwoDates(
                              //       new Date(),
                              //       new Date(
                              //         semesterContext.selectedSemester?.final_assess_date
                              //       )
                              //     )
                              //   )
                              //   {
                              //     return (
                              //       <StyledTableCell
                              //         key={column.id}
                              //         onClick={(e) => {
                              //           e.stopPropagation();
                              //         }}
                              //         align={column.align}
                              //       >
                              //         <CreditsDropdown
                              //           credit={row}
                              //           openRecordModal={openRecordModal}
                              //           openExtendModal={openExtendModal}
                              //           openDeleteModal={openDeleteModal}
                              //           openArchiveModal={openArchiveModal}
                              //         />
                              //       </StyledTableCell>
                              //     );
                              //   }
                              // }
                              if (column.id === "detail") {
                                return (
                                  <StyledTableCell
                                    key={column.id}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    align={column.align}
                                  >
                                    <Button
                                      onClick={() => {
                                        setIsDetailOpen(true);
                                        setSelectedRow(row);
                                      }}
                                      style={{
                                        padding: "7px",

                                        alignSelf: "center",
                                        // width: 20,
                                        zIndex: isMobile ? 1 : 999,
                                        // height: 40,
                                      }}
                                      status={Status.blue}
                                      isFullwidth
                                    >
                                      Details
                                    </Button>
                                  </StyledTableCell>
                                );
                              }
                              if (column.id === "assessed_skills") {
                                if (row.transferred === true) {
                                  return (
                                    <StyledTableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      Transferred
                                    </StyledTableCell>
                                  );
                                }
                                return (
                                  <StyledTableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {value}
                                  </StyledTableCell>
                                );
                              }
                              if (column.id === "status") {
                                if (row.status === "Recorded") {
                                  return (
                                    <StyledTableCell
                                      style={{ color: "#0cff0c" }}
                                      key={column.id}
                                      align={column.align}
                                    >
                                      Recorded
                                    </StyledTableCell>
                                  );
                                }
                                return (
                                  <StyledTableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {value}
                                  </StyledTableCell>
                                );
                              }
                              if (column.id === "provides_credit") {
                                if (!row.transferred) {
                                  return (
                                    <StyledTableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      --
                                    </StyledTableCell>
                                  );
                                } else
                                  return (
                                    <StyledTableCell
                                      key={column.id}
                                      align={column.align}
                                    >
                                      {row.provides_credit ? (
                                        <Icon
                                          fixedWidth={false}
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            color: "#0cff0c",
                                          }}
                                          size={3}
                                          mr={1}
                                          name="check"
                                        />
                                      ) : (
                                        <Icon
                                          // fixedWidth={false}
                                          style={{
                                            width: "24px",
                                            height: "24px",
                                            color: "red",
                                          }}
                                          size={3}
                                          mr={1}
                                          name="times"
                                        />
                                      )}
                                    </StyledTableCell>
                                  );
                              }
                              return (
                                <StyledTableCell
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </StyledTableCell>
                              );
                            })}
                          </StyledTableRow>
                        );
                    })}
                  </>
                )}
              </TableBody>
            </TableComponent>
          )}
        </Col>
      </CustomRow>
    </>
  );
}
export default InstructorStudentCreditsPage;
